import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-seven',
  templateUrl: './two-seven.component.html',
  styleUrls: ['./two-seven.component.scss']
})
export class TwoSevenComponent implements OnInit {
  fullWidth=false;
  showSideMenu = false;
  constructor() { }

  ngOnInit(): void {
    this.checkRoute();
  }

  splitUrl(){
    let url=location.pathname.split('/');
    // console.log(url);
    if(url.length === 5){
      this.showSideMenu=true;
      this.fullWidth=false;
    }
    else{
      this.showSideMenu=false;
      this.fullWidth=true;
    }
  }
  checkRoute(){
    setTimeout(()=>{
      this.splitUrl();
    })
  }
}
